export const FIELD_LABELS: Record<string, string> = {
  nomeEmpresa: 'Nome da empresa',
  cep: 'CEP',
  numero: 'Número',
  logradouro: 'Logradouro',
  complemento: 'Complemento',
  bairro: 'Bairro',
  estado: 'Estado',
  cidade: 'Cidade',
  cnpj: 'CNPJ',
  setorAtuacao: 'Setor de atuação',
  areaCriacao: 'Ano criação',
  regimeFiscal: 'Regime fiscal',
  quantidadeVidas: 'Quantidade de vidas',
  modeloTrabalho: 'Modelo de trabalho dos colaboradores',
  nomeEntrevistado: 'Nome',
  cargoEntrevistado: 'Cargo',
  telefoneEntrevistado: 'Telefone',
  emailEntrevistado: 'E-mail',
  turnoverAnual: 'Turnover anual (%)',
  taxaAbsenteismo: 'Taxa de absenteísmo (%)',
  principalDor: 'Principal dor identificada',
  principalObjetivo: 'Principal objetivo do cliente',
  observacoesInternas: 'Observações internas',
  valorTitularCompulsorio: 'Valor compulsório (R$)',
  valorDependenteCompulsorio: 'Valor compulsório (R$)',
  valorTitularAdesao: 'Valor por adesão (R$)',
  valorDependenteAdesao: 'Valor por adesão (R$)',
  qtdTitularCompulsorio: 'Quantidade titular compulsório',
  qtdDependenteCompulsorio: 'Quantidade dependente compulsório',
  qtdTitularAdesao: 'Quantidade titular adesão',
  qtdDependenteAdesao: 'Quantidade dependente adesão',
};
